// @packages
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import styles from './styles';

const IconButton = ({
    classes,
    disabled,
    icon,
    onClick,
    title,
    visible
}) => {
    if (!visible) {
        return null;
    }

    const button = (
        <Button
            classes={{ root: classes.root, disabled: classes.disabled }}
            color="primary"
            disabled={disabled}
            onClick={onClick}
            variant="contained"
        >
            <i className={icon} style={{ fontSize: '1.688rem', color: 'white' }} />
        </Button>
    );

    return disabled
        ? (button)
        : (<Tooltip title={title}>{button}</Tooltip>);
};

IconButton.propTypes = {
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    visible: PropTypes.bool
};

IconButton.defaultProps = {
    disabled: false,
    visible: true
};

export default withStyles(styles)(IconButton);
